import { EndpointBuilder, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import { FetchBaseQueryMeta } from "@reduxjs/toolkit/query";
import createQuery from './createQuery';
import createMutation from './createMutation';

export const createServiceQuery = (responseHandler: (response: any, api: any, arg: any) => void) => (
    builder: EndpointBuilder<
        BaseQueryFn<any, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
        never,
        'baseApi'
    >
) => {
    return createQuery(
        builder,
        (response, api, arg) => {
            responseHandler(response, api, arg);
        }
    );
}

export const createServiceMutation = (responseHandler: (response: any, api: any, arg: any) => void) => (
    builder: EndpointBuilder<BaseQueryFn<any, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, never, 'baseApi'>
) => {
    return createMutation(
        builder,
        (response, api, arg) => {
            responseHandler(response, api, arg);
        }
    );
};